namespace('compass.demographic');

compass.require('compass.demographic.PersonalInfoWidget');

compass.demographic.GroupInfoWidget = compass.defineWidget(function GroupInfoWidget(options) {
	/***
	 * Group contact info widget
	 *
	 * This is the field set that has the group name and then the personal contact info for
	 * the group manager.
	 */
	var $j = jQuery;
	var _settings = options;
	var _fields = {};
	var _personalInfo;
	var _validator = options.validator;

	var _labels = {
		group_name: {
			label: "Group Name",
			hint: "A valid group name is required"
		}
	};

	var d = $j.dom.getContext(this);
	var _me = this;

	var buildValueSet = function () {
		if (_settings.prefill) {
			return { };
		}
		/***
		 * Builds an associative array of the values from the input fields
		 */
		var set = {};
		var personalVals = _personalInfo.grabValues();

		for (var name in _fields) {
			set[name] = _fields[name].val();
		}
		set["personal"] = personalVals;

		return set;
	};
	this.get = this.grabValues = buildValueSet;

	var buildHTML = function (widgetElem) {
		if (_settings.prefill) {
			widgetElem.append(
				d.div({
					className: "prefilled"
				}, d.span({
						className: "groupName"
					}, _settings.prefill.groupName),
					d.span({
						className: "categoryName"
					}, _settings.prefill.categoryName),
					d.div({
						className: "contactName"
					}, _settings.prefill.firstName + " " + _settings.prefill.lastName),
					d.div({
						className: "email"
					}, _settings.prefill.email),
					d.div({
						className: "phone"
					}, _settings.prefill.phone)
				)
			);
			return;
		}
		/***
		 * Builds the HTML elements to be inserted into the /document/,
		 * this includes the personal info fields from the /PersonalInfoWidget/
		 */
		var personalInfoContainer = d.div({
				className: 'personalInfoContainer'
			});
		widgetElem.append(
			drawGroupName(),
			personalInfoContainer
		);
		_personalInfo = new compass.demographic.PersonalInfoWidget(
				personalInfoContainer, {
					WUID: _settings.WUID,
					validator: _validator,
					editablePrefill: _settings.editablePrefill
				}
			);
	};
	this.render = this.build = buildHTML;

	var drawGroupName = function () {
		/***
		 * Draws the input/label pair for the group name field.
		 */
		var name = "groupName";
		var label = _labels.group_name.label;

		var input = d.input({
				type : "text",
				name: name,
				value: _settings.editablePrefill ? _settings.editablePrefill.companyName : '',
				className: name,
				autocomplete: 'off',
				'data-parsley-error-message': _labels.group_name.hint,
				'data-parsley-required': 'true',
				'data-parsley-pattern': /[^\d\s\.]/  //Contains at least 1 alpha
			}).data("hint", _labels.group_name.hint);
		_fields[name] = input;
		if (_validator) {
			_validator.addFields(input, _validator.FILLED, { });
		}

		return d.fieldLabelPair({
			className: name,
			label: label
		}, [input]);
	};
	this.drawGroupName = drawGroupName;

}, {
	WUID : 'CRAP',
	widgetName : 'GroupInfoWidget',
	contact_header: 'Group Contact',
	prefill: null
});
